// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/SwapLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var SwapLeftOutlined = function SwapLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapLeftOutlinedSvg
  }));
};

SwapLeftOutlined.displayName = 'SwapLeftOutlined';
export default React.forwardRef(SwapLeftOutlined);